import { create } from "zustand";

interface SyncStatusState {
  isNotesSynced: boolean;
  isFileSystemReady: boolean;
  setNotesSynced: (synced: boolean) => void;
  setFileSystemReady: (ready: boolean) => void;
}

export const useSyncStatusStore = create<SyncStatusState>((set) => ({
  isNotesSynced: false,
  isFileSystemReady: false,
  setNotesSynced: (synced) => set({ isNotesSynced: synced }),
  setFileSystemReady: (ready) => set({ isFileSystemReady: ready }),
}));
